import { createSlice } from '@reduxjs/toolkit'

const STORAGE_KEY = 'firmLoginInfo'

const emptyState = {
    isLog: false,
    byxkh_yh_id: null,
    byxkh_yh_name: null,
    byxkh_yh_phone: null,
    byxkh_yh_password: null,
    byxkh_yh_state: null,
    byxkh_yh_ctime: null,
    byxkh_yh_cname: null,
    byxkh_yh_kh_id: null,
    byxkh_yh_kh_name: null,
}

function getInitialState() {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return emptyState
    try {
        const parsed = JSON.parse(raw)
        return { ...emptyState, ...parsed, isLog: Boolean(parsed?.isLog) }
    } catch (error) {
        localStorage.removeItem(STORAGE_KEY)
        return emptyState
    }
}

const firmLoginSlice = createSlice({
    name: 'firmLogin',
    initialState: getInitialState,
    reducers: {
        setFirmLogin(state, action) {
            const payload = action.payload || {}
            state.isLog = true
            state.byxkh_yh_id = payload.byxkh_yh_id ?? null
            state.byxkh_yh_name = payload.byxkh_yh_name ?? null
            state.byxkh_yh_phone = payload.byxkh_yh_phone ?? null
            state.byxkh_yh_password = payload.byxkh_yh_password ?? null
            state.byxkh_yh_state = payload.byxkh_yh_state ?? null
            state.byxkh_yh_ctime = payload.byxkh_yh_ctime ?? null
            state.byxkh_yh_cname = payload.byxkh_yh_cname ?? null
            state.byxkh_yh_kh_id = payload.byxkh_yh_kh_id ?? null
            state.byxkh_yh_kh_name = payload.byxkh_yh_kh_name ?? null
            localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
        },
        clearFirmLogin(state) {
            Object.assign(state, emptyState)
            localStorage.removeItem(STORAGE_KEY)
        },
    },
})

export const { setFirmLogin, clearFirmLogin } = firmLoginSlice.actions
export const { reducer: firmLoginReducer } = firmLoginSlice
